export const iconFontAwesomeMoneyLandmark = (
	<i className="fa-solid fa-landmark"></i>
);
